import { render } from "./StarReit.vue?vue&type=template&id=46c0cb3f&scoped=true"
import script from "./StarReit.vue?vue&type=script&lang=js"
export * from "./StarReit.vue?vue&type=script&lang=js"

import "./StarReit.vue?vue&type=style&index=0&id=46c0cb3f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c0cb3f"]])

export default __exports__